























































import settings from '../settings.coffee'
import queries from "@/gql/queries.coffee"
import mutations from "@/gql/mutations.coffee"
import moment from "moment"
import utils from '@/utils.js'
import query from '@/gql/queries'

import LogosSingleAnswer from '@/components/LogosSingleAnswer'
import LogosAdditionalAnswer from '@/components/LogosAdditionalAnswer'

moment.locale("fr")

export default {
    "name": "LogosAnswer"
    "components":{
      LogosSingleAnswer,
      LogosAdditionalAnswer
    }
    data: ()->
      return {
        answers: [],
        review: null,
        error: null,
        height: "800px",
        generating: false,
        can_use_as_example: false,
        use_as_logos_example: false,
        answers_with_scores: null,
        total_answers_for_etab_and_sentiment: null,
        scores_progress_ratio: null,
        can_generate_new_answer: false;
        single_answer_key: 0,
      }
    watch:
      "$store.state.selected_review_uid": (old_value, new_value)->
        if old_value != new_value
          this.error = null
          await this.fetch_answers()
          await this.fetch_review()
          await this.fetch_scores_progress()
          this.use_as_logos_example = this.review.use_as_logos_example
    computed:
      "component_style": ()->
        # height: 800px; overflow-y: scroll
        return {
          "height": this.height,
          "overflow-y": scroll
        }
    methods:
      "reload_answers": () ->
        this.single_answer_key = this.single_answer_key + 1
      "update_use_as_logos_example": (event)->
        new_value = event.target.checked
        response = await this.$http.post(settings.graphqlApiUrl, {query: mutations.gql_mutation_review_set_use_as_example(this.$store.state.selected_review_uid, new_value)})
        if response.ok
          this.use_as_logos_example = new_value
      "generate_answer": ()->
        self = this
        self.generating = true
        response = await self.$http.post(settings.graphqlApiUrl, {query: mutations.review_generate_logos_answer(self.$store.state.selected_review_uid)})
        if response.ok
          if response.body.data.review_generate_logos_answer.ok
            await self.fetch_answers()
            self.error = null
          else
            self.error = response.body.data.review_generate_logos_answer.msg
        else
          self.error = response.body.data
        self.generating = false
      "human_datetime": (value)->
        return moment(value).format('DD/MM/YYYY HH:mm:ss')
      
      "fetch_answers": ()->
        self = this
        if self.$store.state.selected_review_uid?
          # Ensure that all games exists between answers
          # This is computed every time someone consult the Logos tab
          # Sometime some Games were not present and a click on the button "Cette réponse est la meilleure" did not work because of missing games
          # ensure that all games are present
          response = await self.$http.post(settings.graphqlApiUrl, {query: mutations.review_ensure_all_games(self.$store.state.selected_review_uid)})
          # fetch the answers
          response = await self.$http.post(settings.graphqlApiUrl, {query: queries.gql_query_answer_set(self.$store.state.selected_review_uid)})
          if response.ok
            self.answers = response.body.data.answer_set
          else
            self.answers = []
        self.reload_answers()

      "fetch_review": ()->
        self = this
        self.review = null
        self.use_as_logos_example = false
        if self.$store.state.selected_review_uid?
            response = await self.$http.post(settings.graphqlApiUrl, {query: queries.gql_query_review_detail(self.$store.state.selected_review_uid)})
            if response.ok
                self.review = response.body.data.review
                self.use_as_logos_example = self.review.use_as_logos_example
          
            # Check if this review can be used as a Logos example
            # It must be in the state: "Classé répondu"
            response = await self.$http.post(settings.graphqlApiUrl, {query: queries.gql_review_can_be_used_as_logos_example(self.$store.state.selected_review_uid)})
            if response.ok
              self.can_use_as_example = response.body.data.review_can_be_used_as_logos_example.can_use_as_example
          self.reload_answers()

      "fetch_scores_progress": ()->
        # Fetch two numbers: total number of answers for a given establishment and sentiment and number of answers with scores
        self = this
        if self.$store.state.selected_review_uid?
          response = await self.$http.post(settings.graphqlApiUrl, {query: queries.gql_review_scores_progress(self.$store.state.selected_review_uid)})
          if response.ok
            self.answers_with_scores = response.body.data.review_scores_progress.answers_with_scores
            self.total_answers_for_etab_and_sentiment = response.body.data.review_scores_progress.total_answers_for_etab_and_sentiment
            self.scores_progress_ratio = response.body.data.review_scores_progress.scores_progress_ratio
      "set_height": ()->
        self = this
        utils.debounce(
            ()->
                self.height = (window.innerHeight-65)+ "px"
                return
            , 500)
      "fetch_assistants": ()->
        self = this
        resp = await query.run_v2('assistants')
        if resp.ok
          self.assistants = resp.body.data.assistants
    "mounted": ()->
      await this.fetch_answers()
      await this.fetch_review()
      await this.fetch_scores_progress()
      this.set_height()
      window.addEventListener('resize', this.set_height)
      this.can_generate_new_answer = this.$store.state.profile.permissions.includes("game.can_generate_answer")
}
